module.exports = __webpack_public_path__ + "static/img/cont64 (3).dabab9a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont64 (3).jpg
// module id = rcIj
// module chunks = 0